import axios from "axios";

var AUTH_KEYS = [
  "revizeTrainingToken",
  "loggedInUserId",
  "userRole",
  "firstName",
  "loggedInUserEmail",
  "loggedInUserActiveStatus",
];

// Clear leftover auth keys from earlier localStorage experiments.
function migrateAuthToSessionStorage() {
  try {
    AUTH_KEYS.forEach(function (key) {
      if (!sessionStorage.getItem(key)) {
        var leftover = localStorage.getItem(key);
        if (leftover) {
          sessionStorage.setItem(key, leftover);
        }
      }
      localStorage.removeItem(key);
    });
    localStorage.removeItem("revizeSessionAliveAt");
    localStorage.removeItem("revizeSessionPing");
    localStorage.removeItem("revizeSessionPong");
    sessionStorage.removeItem("revizeSessionActive");
  } catch (e) {}
}

export function clearAuthStorage() {
  AUTH_KEYS.forEach(function (key) {
    try {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key);
    } catch (e) {}
  });
}

migrateAuthToSessionStorage();

function isAuthUrl(url) {
  var value = String(url || "");
  return (
    value.indexOf("/api/token") !== -1 ||
    value.indexOf("/generate_totp_auth_uri") !== -1 ||
    value.indexOf("/verify_totp") !== -1 ||
    value.indexOf("/forgot-password") !== -1
  );
}

function isAppApiUrl(url) {
  var value = String(url || "");
  if (!value) return false;
  var server = process.env.REACT_APP_SERVER_URL || "";
  if (server && value.indexOf(server) !== -1) return true;
  return value.indexOf("/api/") !== -1 || isAuthUrl(value);
}

var redirectToSignIn = function () {
  clearAuthStorage();
  window.location.href = "/auth/sign-in";
};

function hasAuthorization(headers) {
  if (!headers) return false;
  if (typeof Headers !== "undefined" && headers instanceof Headers) {
    return headers.has("Authorization");
  }
  var key;
  for (key in headers) {
    if (Object.prototype.hasOwnProperty.call(headers, key) && String(key).toLowerCase() === "authorization") {
      return true;
    }
  }
  return false;
}

function applyFetchAuth(input, init, token) {
  if (!token || token === "null") {
    return [input, init];
  }
  var url =
    typeof input === "string" ? input : input && input.url ? input.url : "";
  if (!isAppApiUrl(url) || isAuthUrl(url)) {
    return [input, init];
  }
  try {
    if (typeof Request !== "undefined" && input instanceof Request) {
      if (hasAuthorization(input.headers)) {
        return [input, init];
      }
      var requestHeaders = {};
      input.headers.forEach(function (value, key) {
        requestHeaders[key] = value;
      });
      requestHeaders.Authorization = "Bearer " + token;
      return [new Request(input, { headers: requestHeaders }), init];
    }
    var nextInit = init ? Object.assign({}, init) : {};
    if (hasAuthorization(nextInit.headers)) {
      return [input, init];
    }
    if (typeof Headers !== "undefined" && nextInit.headers instanceof Headers) {
      nextInit.headers = new Headers(nextInit.headers);
      nextInit.headers.set("Authorization", "Bearer " + token);
    } else {
      nextInit.headers = Object.assign({}, nextInit.headers || {}, {
        Authorization: "Bearer " + token
      });
    }
    return [input, nextInit];
  } catch (e) {
    return [input, init];
  }
}

function bindHttpHooks() {
  if (window.__revizeHttpHooksBound) {
    return;
  }
  window.__revizeHttpHooksBound = true;

  axios.interceptors.request.use(
    function (config) {
      var token = null;
      try {
        token = sessionStorage.getItem("revizeTrainingToken");
      } catch (e) {}
      if (token && token !== "null" && !isAuthUrl(config.url)) {
        if (!config.headers) {
          config.headers = {};
        }
        if (typeof config.headers.set === "function") {
          config.headers.set("Authorization", "Bearer " + token);
        } else {
          config.headers["Authorization"] = "Bearer " + token;
        }
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && error.response.status === 401) {
        var url = error.config && error.config.url ? error.config.url : "";
        if (!isAuthUrl(url)) {
          redirectToSignIn();
        }
      }
      if (error.code === "ERR_NETWORK") {
        return Promise.reject(error.code);
      }
      return Promise.reject(error);
    }
  );

  if (!window.__revizeOriginalFetch) {
    window.__revizeOriginalFetch = window.fetch.bind(window);
  }
  var originalFetch = window.__revizeOriginalFetch;
  window.fetch = function (input, init) {
    var url =
      typeof input === "string" ? input : input && input.url ? input.url : "";
    var token = null;
    try {
      token = sessionStorage.getItem("revizeTrainingToken");
    } catch (e) {}
    var authed = applyFetchAuth(input, init, token);
    return originalFetch.apply(window, authed).then(
      function (response) {
        if (response.status === 401) {
          if (!isAuthUrl(url)) {
            redirectToSignIn();
          }
        }
        return response;
      },
      function (err) {
        return Promise.reject(err);
      }
    );
  };
}

bindHttpHooks();
